import { Injectable } from '@angular/core';
import { PrepareImportForUploadDto } from '@interfaces/HttpClient/CatalogApiModels';
import { Subject } from 'rxjs';
import { AzureBlobService } from './azure-blob.service';
import { GlobalVarService } from './global-var.service';

@Injectable({
	providedIn: 'root'
})
export class CatalogUploadService {


	constructor(private blobService: AzureBlobService, private globalVarService: GlobalVarService) { }

	private static cancelCall: Subject<void> = new Subject<void>();
	private static progressCall: Subject<any> = new Subject<any>();
	private static uploadFinished: Subject<void> = new Subject<void>();
	private static errorCall: Subject<void> = new Subject<void>();

	public upload(file: File, url: string, importConfig: PrepareImportForUploadDto) {
		this.globalVarService.setCatalogUploading(importConfig);
		CatalogUploadService.progressCall.next(0)
		this.blobService.uploadFinishedCall.subscribe(() => {
			CatalogUploadService.uploadFinished.next();
		});
		this.blobService.progressCall.subscribe(progress => {
			this.globalVarService.setCatalogUploading(importConfig);
			CatalogUploadService.progressCall.next(progress)
		})
		this.blobService.errorCall.next(err => CatalogUploadService.errorCall.next(err));
		this.blobService.upload(file, url);

	}

	public cancel() {
		this.globalVarService.deleteCatalogUploading();
		this.blobService.cancel();
		CatalogUploadService.cancelCall.next();
	}

	public getErrorCall(): Subject<any> {
		this.globalVarService.deleteCatalogUploading();
		return CatalogUploadService.errorCall;
	}

	public getProgress(): Subject<any> {
		return CatalogUploadService.progressCall;
	}

	public getFinishedUpload(): Subject<void> {
		return CatalogUploadService.uploadFinished;
	}

	public getCancelCall() {
		return CatalogUploadService.cancelCall;
	}

	public getCurrentUploadInfos() {
		return this.globalVarService.getCatalogUploading()
	}



}
